// extracted by mini-css-extract-plugin
export var banner = "_p9-0";
export var settingRow = "_p9-2";
export var titleIcon = "_p9-1";